import { render } from "./TimeSlotByDaySectors.vue?vue&type=template&id=3de57fec&scoped=true&ts=true"
import script from "./TimeSlotByDaySectors.vue?vue&type=script&lang=ts"
export * from "./TimeSlotByDaySectors.vue?vue&type=script&lang=ts"

import "./TimeSlotByDaySectors.vue?vue&type=style&index=0&id=3de57fec&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de57fec"]])

export default __exports__